module.exports = __webpack_public_path__ + "static/media/logo_benchmarc.3dfa461c.svg";